// A task was created somewhere other than the list showing it — a task
// suggested from a note, an auto-proposed task, the global proposals pop-up —
// so any mounted task list re-fetches. A window event rather than a prop chain
// because the creators (NotesFeed, TaskProposalsModal) are siblings or strangers
// to the list (DealTasksPanel), not its parents.
export const TASKS_CHANGED_EVENT = 'harvus-tasks-changed';

export const notifyTasksChanged = () => {
  try { window.dispatchEvent(new CustomEvent(TASKS_CHANGED_EVENT)); } catch { /* no window (tests) */ }
};

export const onTasksChanged = (handler) => {
  if (typeof window === 'undefined') return () => {};
  window.addEventListener(TASKS_CHANGED_EVENT, handler);
  return () => window.removeEventListener(TASKS_CHANGED_EVENT, handler);
};
